import { post2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const useInternalNotificationsReplyPost = () => {
  const branchId = useBranchId();

  const { t } = useTranslation();

  const replyCustomer = useMutation({
    mutationFn: ({ itemId, message }: { itemId: number; message: string }) => {
      return post2(
        `/internal/secure/pos/v1/internal/notifications/reply/to/${branchId}/${itemId}`,
        { message }
      );
    },
    onSuccess: () => {
      toast.success(t("notifications.replySent"));
    },
  });

  const replyAppsmen = useMutation({
    mutationFn: ({ message }: { message: string }) => {
      return post2(
        `/internal/secure/pos/v1/internal/notifications/response/appsmen/${branchId}`,
        { message }
      );
    },
    onSuccess: () => {
      toast.success(t("notifications.replySent"));
    },
  });

  return { replyCustomer, replyAppsmen };
};

export default useInternalNotificationsReplyPost;
